/**
 * Converting pvalue to number
 *
 * @param pValue - pvalue
 * @returns pvalue as a number
 */
export const convertPValueToNumber = (pValue) => (pValue === null || pValue === '' ? null : +pValue);
